import { get, find } from 'underscore';

export function getBoostSetting(adgroup) {
  const adGroupSettings = get(adgroup, 'Settings', []);

  const BoostPlacementSetting = find(adGroupSettings, setting => setting['@odata.type'] === '#Model.BoostPlacementSetting') || {};

  return {
    accountIds: BoostPlacementSetting.AccountIds,
    adUnitIds: BoostPlacementSetting.AdUnitIds,
    publisherIds: BoostPlacementSetting.PublisherIds,
    triggerIds: BoostPlacementSetting.TriggerIds,
  };
}
